import allConfig from "../../config.json";

let URL = allConfig.baseRoute + "/v1/user";

export default (route, config = {}) => {
  if (
    config.body &&
    config.headers["Content-Type"] !== "multipart/form-data" &&
    config.headers["Content-Type"] !== undefined
  )
    config.body = JSON.stringify(config.body);
  return fetch(URL + route, config).then((response) => {
    if (response.status === 401) {
      localStorage.removeItem(allConfig.jwtName);
    }
    return response.json();
  });
};
